import { replace } from 'connected-react-router'

export const checkIfRedirectNeeded = ({ 'endeca:redirect': redirectData }) => redirectData

const urlSchemeRegex = /^(([a-z][\w+\-.]*):)?\/\//

export const redirect = ({ link: { url }}) => urlSchemeRegex.test(url) ? window.location.replace(url) : replace(url)

